import React from 'react';
import { Grid, Header, Icon, Button, Label } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const formatDateForView = (isoDate) => {
  if (!isoDate) return '';
    return isoDate.split('T')[0].split('-').reverse().join('.');
};

const getAdvertisingStatus = ({ isActive, startDate, endDate }) => {
  const now = new Date()

  const start = startDate ? new Date(startDate) : null
  const end = endDate ? new Date(endDate) : null

  if (isActive === 1) {
    return 'published'
  }

  if (start && start > now) {
    return 'scheduled'
  }

  if (end && end < now) {
    return 'expired'
  }

  if (
    (!start || start <= now) &&
    (!end || end >= now)
  ) {
    return 'published'
  }
  return 'inactive'
}

const AdvertisingListItem = (props) => {
  const { t } = useTranslation();

  const STATUS_META = {
    scheduled: {
      label: t('label-advertising-scheduled'),
      color: 'blue'
    },
    published: {
      label: t('label-advertising-published'),
      color: 'green'
    },
    expired: {
      label: t('label-advertising-expired'),
      color: 'grey'
    },
    inactive: {
      label: t('label-advertising-inactive'),
      color: 'red'
    },
    unknown: {
      label: t('label-advertising-unknown'),
      color: null
    }
  }
  const statusKey = getAdvertisingStatus(props)
  const status = STATUS_META[statusKey]
  
  return(
    <Grid columns='equal' stackable verticalAlign='middle' key={`advertising-list-item-${props.id}`}>
      <Grid.Column>
        <Header as='h2'>{props.title}</Header>
        {props.subtitle && (
          <p style={{ color: '#6b7280' }}>
            {props.subtitle}
          </p>
        )}
      </Grid.Column>
      <Grid.Column>
        <Grid columns={1} verticalAlign='middle' style={{margin: 'auto'}}>
          <Grid.Column>
            <Label size="medium" color={status.color}>
              <Icon name={
                statusKey === 'published' ? 'check circle' :
                statusKey === 'scheduled' ? 'clock outline' :
                statusKey === 'expired' ? 'ban' :
                'question circle'
              } />
              {status.label}
            </Label>
          </Grid.Column>
        </Grid>
      </Grid.Column>
      <Grid.Column>
        <Header style={{fontSize: '1.4rem'}}>{t('label-startDate_endDate')}</Header>
        <p>
          <Icon name='play' color='teal' />
          {t('label-startDate')} {formatDateForView(props.startDate)}<br />
          <Icon name='stop' color='teal' />
          {t('label-endDate')} {formatDateForView(props.endDate)}<br/>
        </p>
      </Grid.Column>
      <Grid.Column>
        <Button.Group floated='right'>
          <Button primary size='medium' onClick={()=>props.onClickEdit({id: props.id, title: props.title})}><Icon name='edit' />{t('button-detail')}</Button>
        </Button.Group>
      </Grid.Column>
    </Grid>
  )
}

export default AdvertisingListItem